export default __webpack_public_path__ + "static/media/boatshow.f4b7bf11.svg";